<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>日志模块</el-breadcrumb-item>
            <el-breadcrumb-item>员工操作记录</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="0"
            class="grid-content">
      <el-col :span="7">
        <div class="grid-content">
          员工姓名:
          <el-input v-model="input"
                    style="width: unset;"
                    placeholder="请输入员工姓名"></el-input>
        </div>
        <div class="grid-content">
          员工电话:
          <el-input v-model="input"
                    style="width: unset;"
                    placeholder="请输入员工电话"></el-input>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="grid-content">
          时间：
          <el-date-picker v-model="value1"
                          type="daterange"
                          style="width: 220px;"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"></el-date-picker>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="grid-content">
          类型:
          <el-select v-model="value"
                     filterable
                     placeholder="请选择">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="grid-content">
          <el-button type="primary"
                     size="small">查询</el-button>
        </div>
      </el-col>

    </el-row>
    <el-table :data="tableData"
              border
              style="width: 95%">
      <el-table-column prop="date"
                       label="操作时间"
                       width="100">
      </el-table-column>
      <el-table-column prop="name"
                       label="名称"
                       width="100">
      </el-table-column>
      <el-table-column prop="phone"
                       label="手机号"
                       width="100">
      </el-table-column>
      <el-table-column prop="type"
                       label="操作类型"
                       width="120">
      </el-table-column>
      <el-table-column prop="message"
                       label="操作类容">
      </el-table-column>
    </el-table>
    <el-pagination class="grid-content"
                   background
                   layout="prev, pager, next"
                   :total="1000">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      value1: '',
      options: [
        {
          value: '0',
          label: '全部'
        },
        {
          value: '1',
          label: '新增员工'
        },
        {
          value: '2',
          label: '修改密码'
        },
        {
          value: '3',
          label: '离职'
        },
        {
          value: '4',
          label: '重新入职'
        },
        {
          value: '5',
          label: '基本信息修改'
        }
      ],
      value: '',
      tableData: [{
        date: '2016-05-02',
        name: '笨笨',
        phone: '1840927298',
        batch: '校服',
        type: '新增批次',
        message: '新增笨笨'
      }]
    }
  },
  methods: {
    handleClick (row) {
      console.log(row)
    }
  }
}
</script>
